import React from 'react';
import '../global.css';

export default () => (
	<div>
		Coming soon...
	</div>
);